"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../..");
const { Star: BaseStar, StarFilled: BaseStarFilled } = __1.iconNew;
const Star = (0, styled_components_1.default)(BaseStar) `
  cursor: ${({ isEditable }) => (isEditable ? "pointer" : "normal")};
`;
const StarFilled = (0, styled_components_1.default)(BaseStarFilled) `
  cursor: ${({ isEditable }) => (isEditable ? "pointer" : "normal")};
`;
const Wrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(6, 24px);
  color: ${({ theme }) => theme.primary.main};
`;
const RotaRatingStars = ({ rating, isDisabled, onClick }) => {
    const [hoverIndex, setHoverIndex] = (0, react_1.useState)(null);
    return (react_1.default.createElement(Wrapper, null, Array.from({ length: 6 }).map((_, idx) => (react_1.default.createElement("div", { onMouseOver: () => !isDisabled && onClick && setHoverIndex(idx), onMouseLeave: () => !isDisabled && onClick && setHoverIndex(null) }, rating && idx <= (hoverIndex !== null ? hoverIndex : rating - 1) ? (react_1.default.createElement(StarFilled, { isEditable: !isDisabled, onClick: () => !isDisabled && onClick && onClick(idx + 1) })) : (react_1.default.createElement(Star, { isEditable: !isDisabled, onClick: () => !isDisabled && onClick && onClick(idx + 1) })))))));
};
exports.default = RotaRatingStars;
